import React, { Component } from 'react'
import Moment from 'react-moment';
import axios from 'axios';
import 'moment-timezone';
import 'moment/locale/vi';
import MainCommentBox from './MainCommentBox';

import { withTranslation } from 'react-i18next';
import { detectMob } from '../../../common/utils.js';
import { toast } from 'react-toastify';
import DefaultAvatar from '../../../assets/images/default-avatar.png';

class CommentLine extends Component {

    constructor(props) {
        super(props);
        this.toogle = this.toogle.bind(this);
    }

    toogle() {
        const { commentLv1Id } = this.props;

        if (this.props.commentLv1Id != null) {
            this.props.toggle(commentLv1Id);
        } else {
            this.props.toggle(this.props.comment.key);
        }

    }

    fixUserProfileDomain(userProfile) {
        if (!userProfile) return userProfile;
        return userProfile.replace("http://", window.location.protocol + '//');
    }

    render() {
        const { comment, recording, user, toggleComment, toggleCommentId, t } = this.props;

        const userId = comment.userId;
        const fbAvatar = comment.userProfile ? this.fixUserProfileDomain(comment.userProfile) : DefaultAvatar;
        const fbName = comment.userName;
        const message = comment.message;
        const commentId = comment.key;
        const dateTime = comment.dateTime / 1000;
        const handleAvatarError = (event) => {
            event.target.onerror = null;
            event.target.src = DefaultAvatar;
        };

        const isChild = !!this.props.commentLv1Id;
        const commentThreadClass = [
            "comment-thread",
            isChild ? "comment-thread--child" : ""
        ].join(" ").trim();
        const replyButtonProps = user == null ? { "data-toggle": "modal", "data-target": "#loginDialog" } : {};

        const renderMessageContent = () => {
            if (comment.roomType === "LUCKYGIFT") {
                if (comment.luckyGiftGaveStatus === "NEW") {
                    return (
                        <a
                            href={detectMob() !== "unknown" ? global.config.appName + "://recording?parameters=" + encodeURIComponent("{\"_id\":" + recording._id + ",\"recordingId\":\"" + recording.recordingId + "\"}") : ""}
                        >
                            <img style={{ width: "150px" }} src={message} alt="Lucky gift" />
                        </a>
                    );
                }
                return <img style={{ width: "150px", filter: "brightness(0.6)" }} src={message} alt="Lucky gift" />;
            }
            return message;
        };

        const handleUserClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const url = global.config.apiDomain + '/admin/account-manager?id=' + userId;
            window.open(url, '_blank');
        };

        return (
            <div data-userid={userId} data-commentid={commentId} className={commentThreadClass}>
                <div className="comment-thread__avatar">
                    <a href={global.config.apiDomain + '/admin/account-manager?id=' + userId} onClick={handleUserClick} style={{ cursor: 'pointer' }}>
                        <img className="_1ci img" src={fbAvatar} alt="" onError={handleAvatarError} />
                    </a>
                </div>
                <div className="comment-thread__content">
                    <div className="comment-bubble">
                        <div className="comment-bubble__author-row">
                            <a href={global.config.apiDomain + '/admin/account-manager?id=' + userId} onClick={handleUserClick} className="comment-bubble__author" style={{ cursor: 'pointer' }}>
                                {fbName}
                            </a>
                            {recording.owner.facebookId.includes(userId) && (
                                <span className="comment-bubble__badge">Tác giả</span>
                            )}
                        </div>
                        <div className="comment-bubble__text">
                            {renderMessageContent()}
                        </div>
                    </div>
                    <div className="comment-thread__actions">
                        <button
                            type="button"
                            className="comment-thread__action"
                            {...replyButtonProps}
                            onClick={this.toogle}
                        >
                            {t("recording_page.reply", "Trả lời")}
                        </button>
                        <span className="comment-thread__dot">·</span>
                        <span className="comment-thread__time">
                            <Moment unix fromNow tz="Asia/Ho_Chi_Minh" locale="vi">
                                {dateTime}
                            </Moment>
                        </span>
                    </div>
                    {comment.childs && (
                        <div className="comment-thread__children">
                            {comment.childs.map(e => (
                                <CommentLine
                                    commentLv1Id={commentId}
                                    key={e.key}
                                    comment={e}
                                    recording={recording}
                                    user={user}
                                    toggleComment={toggleComment}
                                    toggleCommentId={toggleCommentId}
                                    toggle={this.toogle}
                                    t={t}
                                ></CommentLine>
                            ))}
                        </div>
                    )}
                    {(toggleComment === true && toggleCommentId === commentId) && (
                        <MainCommentBox
                            recording={recording}
                            user={user}
                            commentLv1Id={commentId}
                            addNewComment={this.props.addNewComment}
                        ></MainCommentBox>
                    )}
                </div>
            </div>
        )
    }
}

export default withTranslation()(CommentLine)

